import Middleware from './middleware'

Middleware.authTrack = async function ({ app, route }) {
  if (!route.path.match('/auth/') && !app.$auth.loggedIn) {
    app.$auth.setRedirect(route.fullPath)
  }
}
